const name = 'circle-5';

const contents = '<path d="M30.544 55.293c-3.535 0-6.766-.69-9.694-2.072l1.326-4.142a19.874 19.874 0 004.101 1.367c1.409.304 2.748.455 4.019.455 1.712 0 3.01-.414 3.894-1.242.884-.829 1.326-1.879 1.326-3.149 0-2.21-1.133-3.687-3.397-4.433-2.265-.746-5.469-1.174-9.612-1.284l.497-14.086h16.489V31.1h-11.6l-.332 5.385c1.934.11 3.729.345 5.386.705 1.657.359 3.093.925 4.309 1.698a8.438 8.438 0 012.858 2.983c.69 1.215 1.036 2.707 1.036 4.474 0 2.652-.939 4.806-2.817 6.463-1.878 1.657-4.474 2.486-7.789 2.486z" fill="#FFF"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: '5',
};

export default icon;
